import { ptBR, es } from 'date-fns/locale';

const CODE_LANG = {
  br: 'pt',
  mx: 'mx',
  cl: 'cl',
  co: 'co',
  ar: 'ar',
  pe: 'pe',
  ec: 'ec',
  do: 'do',
  uy: 'uy',
  cr: 'cr',
  bo: 'bo',
  py: 'py',
  sv: 'sv',
  pa: 'pa',
};

const PAYPAL_LANG = {
  br: 'pt_BR',
  mx: 'es_ES',
  cl: 'es_ES',
  co: 'es_ES',
  ar: 'es_ES',
  pe: 'es_ES',
  ec: 'es_ES',
  do: 'es_ES',
  uy: 'es_ES',
  cr: 'es_ES',
  bo: 'es_ES',
  py: 'es_ES',
  sv: 'es_ES',
  pa: 'es_ES',
};

const LOCALE_STRING = {
  br: 'pt-BR',
  mx: 'es-ES',
  cl: 'es-ES',
  co: 'es-ES',
  ar: 'es-ES',
  pe: 'es-ES',
  ec: 'es-ES',
  do: 'es-ES',
  uy: 'es-ES',
  cr: 'es_ES',
  bo: 'es_ES',
  py: 'es_ES',
  sv: 'es_ES',
  pa: 'es_ES',
};

const DATEFNS_LANG = {
  br: ptBR,
  mx: es,
  cl: es,
  co: es,
  ar: es,
  pe: es,
  ec: es,
  do: es,
  uy: es,
  cr: es,
  bo: es,
  py: es,
  sv: es,
  pa: es,
};

export const getLangByCountry = country => ({
  code: CODE_LANG[country] || CODE_LANG.br,
  paypal: PAYPAL_LANG[country] || PAYPAL_LANG.br,
  dateFns: DATEFNS_LANG[country] || DATEFNS_LANG.br,
  locale: LOCALE_STRING[country] || LOCALE_STRING.br,
});
